module.exports = __webpack_public_path__ + "img/human.af9bb2bf.svg";